import { fetchRequest } from "@providers/conect";

const verCitasRangoApi = async ( data ) => {
  try {
    const url = `agendawp/citas-range`
    const response = await fetchRequest(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { verCitasRangoApi };
